@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../../../settings-page.module.less';

.content {
  height: 100%;
  width: 100%;
}

.rate-shoppers {
  padding: @settings-page-content-padding;
  flex: 1 1 auto;
}

.upsell {
  margin-top: @space-24;
  margin-bottom: @space-16;
}

.first-description {
  margin-bottom: @space-8;
}

.collection-heading {
  align-items: center;
  justify-content: space-between;
}

@media @wide-desktop {
  .rate-shoppers {
    flex: 0 1 980px;
  }
}

@media @medium-desktop {
  .rate-shoppers {
    flex: 0 1 80%;
  }
}
